export default (el: HTMLElement) => {
	const slides: HTMLElement[] = Array.from(el.querySelectorAll('[data-slide]')) ?? []
	const bullets: HTMLElement[] =
		Array.from(el.querySelectorAll('[data-imageslider-bullet]')) ?? []
	const container: HTMLElement = el.querySelector('[data-imageslider-container]')!
	let currentIndex = 0

	const transformToActiveSlide = () => {
		container.style.transform = `translateX(${currentIndex === 0 ? '0%' : `${currentIndex * 100 * -1}%`})`
	}

	const classSets = {
		active: ['border-white', 'text-white'],
		inactive: ['border-transparent', 'text-white/60'],
	}

	const removeActiveBullets = () =>
		bullets.forEach((bullet) => {
			bullet.classList.remove(...classSets.active)
			bullet.classList.add(...classSets.inactive)
		})

	const addActiveBullet = (index: number) => {
		bullets[index].classList.remove(...classSets.inactive)
		bullets[index].classList.add(...classSets.active)
	}

	let touchStart = 0

	function handleTouchStart(e: TouchEvent): void {
		touchStart = e.touches[0].screenX
	}

	function handleTouchMove(e: TouchEvent): void {
		if (touchStart === 0) {
			return
		}

		const currentTouch = e.touches[0].screenX
		const diff = touchStart - currentTouch

		if (diff > 5) {
			if (currentIndex + 1 < slides.length) {
				activateSlide(currentIndex + 1)
			}
		}

		if (diff < -5) {
			if (currentIndex - 1 >= 0) {
				activateSlide(currentIndex - 1)
			}
		}

		touchStart = 0
	}

	const activateSlide = (index: number) => {
		currentIndex = index

		transformToActiveSlide()
		removeActiveBullets()
		addActiveBullet(index)
	}

	slides.forEach((slide) => {
		slide.addEventListener('touchstart', handleTouchStart)
		slide.addEventListener('touchmove', handleTouchMove)
	})

	if (slides && bullets) {
		bullets.forEach((bullet, index) => {
			bullet.addEventListener('click', () => {
				activateSlide(index)
			})
		})
	}
}
